import { useAtomValue } from 'jotai';
import { $CurrentHashtagInfoAsAvailable } from '@hashtag/shared/current-hashtag-info';
import { useTranslation } from 'react-i18next';
import { $CurrentHashtagPopularPosts } from '@hashtag/shared/current-hashtag-post';
import { useMemo } from 'react';
import { ArticleDetailUtil } from 'shared/models/article';
import { IImage } from 'shared/models/media';

export const useHashtagLinkPreviewTitle = (): string => {
  const { t } = useTranslation();
  const hashtag = useAtomValue($CurrentHashtagInfoAsAvailable);

  return t('share_hashtag_header').replace('{hashtag}', hashtag.name);
};

export const useHashtagDescription = (): string => {
  const { t } = useTranslation();

  return t('share_hashtag_body');
};

export const useHashtagCoverImage = (): IImage | null => {
  const { items: hashtagPopularPosts } = useAtomValue($CurrentHashtagPopularPosts);

  return useMemo<IImage | null>(() => {
    if (hashtagPopularPosts.length) {
      return ArticleDetailUtil.getCoverImage(hashtagPopularPosts[0]);
    }

    return null;
  }, [hashtagPopularPosts]);
};
